import React from "react";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { useFormContext } from "react-hook-form";

type ResetPasswordProps = {
  onSubmit: (data: any) => void;
  loading: boolean;
  t: any;
};

const DefaultResetPassword: React.FC<ResetPasswordProps> = ({
  onSubmit,
  loading,
  t,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div
      className="vh-100 d-flex align-items-center"
      style={{ background: "white" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <h5 className="text-center mb-4">{t("resetPassword:title")}</h5>
            <Form onSubmit={onSubmit}>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="reset-password">
                  {t("resetPassword:form.password.label")}
                </Form.Label>
                <Form.Control
                  type="password"
                  id="reset-password"
                  {...register("password")}
                  placeholder={t("resetPassword:form.password.placeholder")}
                  autoComplete="new-password"
                  isInvalid={!!errors.password}
                />
                <Form.Control.Feedback type="invalid">
                  {typeof errors.password?.message === "string"
                    ? errors.password.message
                    : null}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label htmlFor="reset-confirm-password">
                  {t("resetPassword:form.confirmPassword.label")}
                </Form.Label>
                <Form.Control
                  type="password"
                  id="reset-confirm-password"
                  {...register("confirmPassword")}
                  placeholder={t(
                    "resetPassword:form.confirmPassword.placeholder",
                  )}
                  autoComplete="new-password"
                  isInvalid={!!errors.confirmPassword}
                />
                <Form.Control.Feedback type="invalid">
                  {typeof errors.confirmPassword?.message === "string"
                    ? errors.confirmPassword.message
                    : null}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="d-flex justify-content-between">
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading
                    ? t("resetPassword:button.loading")
                    : t("resetPassword:button.submit")}
                </Button>
                <Button variant="secondary" as={Link} to="/login">
                  {t("common:backToLogin")}
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DefaultResetPassword;
